import { render } from "./UiIsActiveBadge.vue?vue&type=template&id=46e1a0ff&ts=true"
import script from "./UiIsActiveBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiIsActiveBadge.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiIsActiveBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46e1a0ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46e1a0ff', __exports__)) {
    api.reload('46e1a0ff', __exports__)
  }
  
  module.hot.accept("./UiIsActiveBadge.vue?vue&type=template&id=46e1a0ff&ts=true", () => {
    api.rerender('46e1a0ff', render)
  })

}


export default __exports__